import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { Banner, LanguageSwitch, Layout } from './components/Layout.tsx';
import { Loading } from './components/ui.tsx';
import { operatorClient } from './lib/supabase.ts';
import { Admin } from './pages/Admin.tsx';
import { BatchDetail } from './pages/BatchDetail.tsx';
import { Batches } from './pages/Batches.tsx';
import { Evidence } from './pages/Evidence.tsx';
import { Genealogy } from './pages/Genealogy.tsx';
import { Guide } from './pages/Guide.tsx';
import { Ingest } from './pages/Ingest.tsx';
import { Landing } from './pages/Landing.tsx';
import { Passport } from './pages/Passport.tsx';
import { RegisterBatch } from './pages/RegisterBatch.tsx';
import { Values } from './pages/Values.tsx';
import { Worklist } from './pages/Worklist.tsx';

function RequireSession({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<'loading' | 'in' | 'out'>('loading');
  useEffect(() => {
    void operatorClient()
      .auth.getSession()
      .then(({ data }) => setState(data.session ? 'in' : 'out'));
  }, []);
  if (state === 'loading') return <Loading />;
  return state === 'in' ? <>{children}</> : <Navigate to="/" replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* public route: no operator client, no session, no storage */}
        <Route path="/p/:upi" element={<Passport />} />
        <Route
          path="/"
          element={
            <>
              <Banner />
              <div className="lang-corner">
                <LanguageSwitch />
              </div>
              <Landing />
            </>
          }
        />
        <Route
          element={
            <RequireSession>
              <Layout />
            </RequireSession>
          }
        >
          <Route path="/batches" element={<Batches />} />
          <Route path="/batches/new" element={<RegisterBatch />} />
          <Route path="/batches/:id" element={<BatchDetail />} />
          <Route path="/batches/:id/compare" element={<BatchDetail compare />} />
          <Route path="/batches/:id/genealogy" element={<Genealogy />} />
          <Route path="/ingest" element={<Ingest />} />
          <Route path="/values" element={<Values />} />
          <Route path="/worklist" element={<Worklist />} />
          <Route path="/evidence" element={<Evidence />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/guide" element={<Guide />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
